export const readAsyncJSON = (key: string): object | null => {
    const value = window.sessionStorage.getItem(key)
    return value ? JSON.parse(value) : null
}

export const readAsync = (key: string): string | null => {
    return window.sessionStorage.getItem(key)
}
